import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './style.css'
import { StyleProvider } from './StyleContext.js';

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
    <StyleProvider>
      <App />
    </StyleProvider>
    </React.StrictMode>
)